import Axios from "axios";

// Base do ai-service, derivada da URL da API .NET.
let aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

export { aiBaseURL };

// Token da sessão corrente, lido na hora da requisição.
export function authToken() {
  try {
    const local = JSON.parse(localStorage.getItem("user-token") || "null");
    return local && local.token ? local.token : null;
  } catch {
    return null;
  }
}

// Cliente autenticado do ai-service. O Authorization é resolvido a cada
// requisição, não na carga do módulo: fixá-lo no load fazia o cliente seguir
// mandando o token da sessão anterior depois de um login em outra conta
// (mesma aba, sem reload), e o ai-service respondia 403 de conta divergente.
export function createAiHttp() {
  const http = Axios.create({ baseURL: aiBaseURL });
  http.interceptors.request.use((config) => {
    const token = authToken();
    if (token) {
      config.headers["Authorization"] = "bearer " + token;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  });
  http.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error && error.response && error.response.status === 401) {
        localStorage.removeItem("user-token");
        window.location.reload();
      }
      return Promise.reject(error);
    }
  );
  return http;
}

// Cliente anônimo (formulários e páginas públicas).
export function createPublicHttp() {
  return Axios.create({ baseURL: aiBaseURL });
}
